export default __webpack_public_path__ + "static/media/No-data-found.8b5ffb44.png";